import { render, staticRenderFns } from "./CmsResourcesList.vue?vue&type=template&id=00232140&"
import script from "./CmsResourcesList.vue?vue&type=script&lang=js&"
export * from "./CmsResourcesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports